const routes = {
    core: '/',
    newsPage: '/news'
}

export { routes };